import React from "react"
import { injectIntl, FormattedMessage } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import { Button, Modal } from "react-bootstrap"
import EcommerceFormFieldsList from "./EcommerceFormFieldsList"
import QuoteFormConfiguration from "../../../state/ecommerce-configuration/EcommerceQuoteFormConfiguration"
import { Link } from "react-router-dom"

type OwnProps = {
    onClose: () => void,
    onFieldSelectCallBack: (field: QuoteFormConfiguration) => void,
    currentFields: [],
}

const EcommerceAddFormFieldsModal = (props: OwnProps & IntlProps) => {

    return (
        <Modal show={true} onHide={props.onClose} centered size={"lg"}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage
                        id="ecommerce.components.ecommerce_add_Form_fields_modal.add_fields.label"
                        defaultMessage="Add Field"
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <EcommerceFormFieldsList
                    currentFields={props.currentFields}
                    onFieldSelectCallBack={props.onFieldSelectCallBack}
                    onClose={props.onClose}
                />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <div className="text-secondary">
                    <FormattedMessage
                        id="ecommerce.components.ecommerce_add_Form_fields_modal.add_custom_fields.label"
                        defaultMessage="You can create more custom fields {here}!"
                        values={{
                            here: <Link to={"/custom-field-definitions/listing"}>
                                <FormattedMessage
                                    id="ecommerce.components.ecommerce_add_Form_fields_modal.add_custom_fields.here"
                                    defaultMessage="here"
                                />
                            </Link>
                        }}
                    />
                </div>
                <Button variant="secondary" onClick={props.onClose}>
                    <FormattedMessage
                        id="common.signature.modal.close_btn"
                        defaultMessage="Close"
                    />
                </Button>
            </Modal.Footer>
        </Modal>
    )
}


export default injectIntl(EcommerceAddFormFieldsModal)


// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceAddFormFieldsModal.tsx